import i18nFactory from '@yandex-int/i18n';
import * as React from 'react';

import { mapStringToCurrencySymbol } from '../../mappers/common/common';
import { Bem } from '../../service/Bem/Bem';
import { ValidationErrorData } from '../../typings/common';
import { CurrencyCode } from '../../typings/graphql-grid';
import { ErrorText, ErrorTextTheme } from '../ErrorText/ErrorText';
import { NumberInput } from '../NumberInput/NumberInput';
import { RequiredMark } from '../RequiredMark/RequiredMark';

import './PhrasesSelectorContextPriceEditor.css';
import * as keyset from './PhrasesSelectorContextPriceEditor.i18n';

const i18n = i18nFactory(keyset);

export interface ContextPriceEditorProps {
    priceContext?: number;
    currency: CurrencyCode;
    error?: ValidationErrorData;
    onChange: (val: string) => void;
    onValueChange: (val: number) => void;
}

const BLOCK = 'phrases-selector-context-price-editor';

export class PhrasesSelectorContextPriceEditor extends React.Component<
    ContextPriceEditorProps
> {
    render() {
        const { currency } = this.props;

        return (
            <div className={Bem.cls(BLOCK)}>
                <div className={Bem.cls(BLOCK, 'price')}>
                    <div className={Bem.cls(BLOCK, 'price-text')}>
                        {i18n('set-context-price')}
                        <RequiredMark cls={Bem.cls(BLOCK, 'required-mark')} />
                    </div>
                    <div className={Bem.cls(BLOCK, 'price-input')}>
                        {this.renderContextPriceInput()}
                    </div>
                    <span className={Bem.cls(BLOCK, 'currency')}>
                        {mapStringToCurrencySymbol(currency)}
                    </span>
                </div>
            </div>
        );
    }

    private renderContextPriceInput = () => {
        const { priceContext, error } = this.props;

        return (
            <NumberInput
                key={'input'}
                theme={'normal'}
                size={'n'}
                value={priceContext}
                valid={!error}
                onChange={this.onContextPriceChange}
                onValueChange={this.onContextValueChange}
                errorText={
                    <ErrorText
                        theme={ErrorTextTheme.tooltip}
                        errors={error ? [error] : undefined}
                    />
                }
            />
        );
    };

    private onContextPriceChange = (value: string) => {
        this.props.onChange(value);
    };

    private onContextValueChange = (value: number) => {
        this.props.onValueChange(value);
    };
}
